import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader-inline',
    templateUrl: './loader-inline.component.html',
    styleUrls: ['./loader-inline.component.scss'],
})
export class LoaderInlineComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
